import type * as T from '../types';

import * as S from './layout';
import SubCategory from './SubCategory';

type Props = {
  subcats: T.SubCategory[];
  category: T.Category;
};

const SubCategories = ({ category, subcats }: Props) => (
  <S.List>
    {subcats.map(subcat => (
      <SubCategory key={subcat.id} category={category} subcat={subcat} />
    ))}
  </S.List>
);

export default SubCategories;
